/* eslint-disable */
/* tslint:disable */

import {
	ActivityAreaRequest,
	ActivityAreaResponse,
	ActivityTypeSimpleResponse,
	ActualViolatorTypeResponse,
	Application,
	BPClassInfoResponse,
	BusinessProcessInfoResponse,
	BusinessProcessPatternInfoResponse,
	ConsequenceParams,
	ConstructionObjectCreateRequest,
	ConstructionObjectInfoResponse,
	ConstructionObjectResponse,
	DirectoryEmptinessResponse,
	DocumentPatternResponse,
	DocumentPatternTypeResponse,
	DocxTemplateRequestParams,
	EmployeeSimpleResponse,
	ImportStatistics,
	InapplicabilityReasonCreateRequest,
	InapplicabilityReasonShortInfo,
	InfluenceObjectInfoResponse,
	MarkerResponse,
	ObjectInfluenceResponse,
	ObjectLocationInfoResponse,
	ObjectStatusRequestParams,
	ObjectStatusResponse, ObjectStatusResponseRELOAD,
	ObjectTypeCreateRequest,
	ObjectTypeResponse,
	OkvedCodeCreateRequest,
	OkvedCodeResponse,
	OkvedCodeSectionCreateRequest,
	OkvedCodeSectionResponse,
	OkvedCodesListItem,
	OrganizationMarkerRequestParams,
	OrganizationMarkersList,
	OrganizationObjectInfoResponse,
	OrganizationParentResponse,
	OrganizationSimpleResponse,
	OrganizationTypeResponse,
	OwnershipTypeCreateRequest,
	OwnershipTypeResponse,
	PersonRelationshipResponse,
	PersonStatusCreateRequest,
	PersonStatusResponse,
	RiskTypeShortResponse,
	SignificanceCriteriaCreateRequest,
	SignificanceCriteriaResponse,
	SignificanceCriteriaSectionInfo,
	String,
	ThreatConsequenceResponse,
	ThreatCreateRequest,
	ThreatModelTemplateResponse,
	ThreatShortInfo,
	ViolatorLevelResponse,
	ViolatorTypeTemplate,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Directory<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка сфер деятельности
	 * @request GET:/directory/activity-areas
	 * @secure
	 */
	activityAreasList = (params: RequestParams = {}) =>
		this.request<ActivityAreaResponse[], void>({
			path: `/directory/activity-areas`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание новой сферы деятельности
	 * @request POST:/directory/activity-areas/create_new_activity-area
	 * @secure
	 */
	activityAreasCreateNewActivityAreaCreate = (data: ActivityAreaRequest, params: RequestParams = {}) =>
		this.request<ActivityAreaResponse, void>({
			path: `/directory/activity-areas/create_new_activity-area`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование существующей сферы деятельности
	 * @request POST:/directory/activity-areas/{activity-area_id}/edit
	 * @secure
	 */
	activityAreasActivityAreaIdEditCreate = (
		activityAreaId: number,
		data: ActivityAreaRequest,
		params: RequestParams = {},
	) =>
		this.request<ActivityAreaResponse, void>({
			path: `/directory/activity-areas/${activityAreaId}/edit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление существующей сферы деятельности
	 * @request POST:/directory/activity-areas/{activity-area_id}/delete
	 * @secure
	 */
	activityAreasActivityAreaIdDeleteCreate = (activityAreaId: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/activity-areas/${activityAreaId}/delete`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Отключение сферы деятельности
	 * @request POST:/directory/activity-areas/{activity-area_id}/disable
	 * @secure
	 */
	activityAreasActivityAreaIdDisableCreate = (activityAreaId: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/activity-areas/${activityAreaId}/disable`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание объекта капитального строительства
	 * @request POST:/directory/construction-object
	 * @secure
	 */
	constructionObjectCreate = (data: ConstructionObjectCreateRequest, params: RequestParams = {}) =>
		this.request<ConstructionObjectResponse, void | String | String[]>({
			path: `/directory/construction-object`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка объектов капитального строительства
	 * @request GET:/directory/construction-object/list
	 * @secure
	 */
	constructionObjectListList = (
		query: {
			/** строка поиска */
			query?: string;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов
			 * @format int32
			 */
			num?: number;
			/** просмотр архива */
			archive?: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<ConstructionObjectResponse[], void>({
			path: `/directory/construction-object/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация об объекте капитального строительства
	 * @request GET:/directory/construction-object/{id}
	 * @secure
	 */
	constructionObjectDetail = (id: number, params: RequestParams = {}) =>
		this.request<ConstructionObjectResponse, void>({
			path: `/directory/construction-object/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование объекта капитального строительства
	 * @request PUT:/directory/construction-object/{id}
	 * @secure
	 */
	constructionObjectUpdate = (id: number, data: ConstructionObjectCreateRequest, params: RequestParams = {}) =>
		this.request<ConstructionObjectResponse, void | String | String[]>({
			path: `/directory/construction-object/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление объекта капитального строительства
	 * @request DELETE:/directory/construction-object/{id}
	 * @secure
	 */
	constructionObjectDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/construction-object/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Помещение объекта капитального строительства в архив
	 * @request GET:/directory/construction-object/{id}/archive
	 * @secure
	 */
	constructionObjectArchiveDetail = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/construction-object/${id}/archive`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Восстановление объекта капитального строительства из архива
	 * @request DELETE:/directory/construction-object/{id}/archive
	 * @secure
	 */
	constructionObjectArchiveDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/construction-object/${id}/archive`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Список типов объектов
	 * @request GET:/directory/object-types
	 * @secure
	 */
	objectTypesList = (
		query?: {
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ObjectTypeResponse[], void>({
			path: `/directory/object-types`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание типа объектов
	 * @request POST:/directory/object/type
	 * @secure
	 */
	objectTypeCreate = (data: ObjectTypeCreateRequest, params: RequestParams = {}) =>
		this.request<ObjectTypeResponse, void | String[]>({
			path: `/directory/object/type`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о типе объектов
	 * @request GET:/directory/object/type/{id}
	 * @secure
	 */
	objectTypeDetail = (id: number, params: RequestParams = {}) =>
		this.request<ObjectTypeResponse, void>({
			path: `/directory/object/type/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование типа объектов
	 * @request PUT:/directory/object/type/{id}
	 * @secure
	 */
	objectTypeUpdate = (id: number, data: ObjectTypeCreateRequest, params: RequestParams = {}) =>
		this.request<ObjectTypeResponse, void | String[]>({
			path: `/directory/object/type/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка видов владений объектами
	 * @request GET:/directory/ownership-types
	 * @secure
	 */
	ownershipTypesList = (
		query?: {
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OwnershipTypeResponse[], void>({
			path: `/directory/ownership-types`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание вида владения объектами
	 * @request POST:/directory/object/ownership
	 * @secure
	 */
	objectOwnershipCreate = (data: OwnershipTypeCreateRequest, params: RequestParams = {}) =>
		this.request<OwnershipTypeResponse, void | String[]>({
			path: `/directory/object/ownership`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о виде владения объектами
	 * @request GET:/directory/object/ownership/{id}
	 * @secure
	 */
	objectOwnershipDetail = (id: number, params: RequestParams = {}) =>
		this.request<OwnershipTypeResponse, void>({
			path: `/directory/object/ownership/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование вида владения объектами
	 * @request PUT:/directory/object/ownership/{id}
	 * @secure
	 */
	objectOwnershipUpdate = (id: number, data: OwnershipTypeCreateRequest, params: RequestParams = {}) =>
		this.request<OwnershipTypeResponse, void | String[]>({
			path: `/directory/object/ownership/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание причины неприменимости показателей критериев значимости
	 * @request POST:/directory/object/kii/inapplicability-reason
	 * @secure
	 */
	objectKiiInapplicabilityReasonCreate = (data: InapplicabilityReasonCreateRequest, params: RequestParams = {}) =>
		this.request<InapplicabilityReasonShortInfo, void | String[]>({
			path: `/directory/object/kii/inapplicability-reason`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка причин неприменимости показателей критериев значимости
	 * @request GET:/directory/object/kii/inapplicability-reason/list
	 * @secure
	 */
	objectKiiInapplicabilityReasonListList = (
		query?: {
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<InapplicabilityReasonShortInfo[], void>({
			path: `/directory/object/kii/inapplicability-reason/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о причине неприменимости показателей критериев значимости
	 * @request GET:/directory/object/kii/inapplicability-reason/{id}
	 * @secure
	 */
	objectKiiInapplicabilityReasonDetail = (id: number, params: RequestParams = {}) =>
		this.request<InapplicabilityReasonShortInfo, void>({
			path: `/directory/object/kii/inapplicability-reason/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование причины неприменимости показателей критериев значимости
	 * @request PUT:/directory/object/kii/inapplicability-reason/{id}
	 * @secure
	 */
	objectKiiInapplicabilityReasonUpdate = (
		id: number,
		data: InapplicabilityReasonCreateRequest,
		params: RequestParams = {},
	) =>
		this.request<InapplicabilityReasonShortInfo, void | String[]>({
			path: `/directory/object/kii/inapplicability-reason/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление причины неприменимости показателей критериев значимости
	 * @request DELETE:/directory/object/kii/inapplicability-reason/{id}
	 * @secure
	 */
	objectKiiInapplicabilityReasonDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/object/kii/inapplicability-reason/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание статуса сотрудников
	 * @request POST:/directory/person/status
	 * @secure
	 */
	personStatusCreate = (data: PersonStatusCreateRequest, params: RequestParams = {}) =>
		this.request<PersonStatusResponse, void | String[]>({
			path: `/directory/person/status`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка возможных статусов сотрудников
	 * @request GET:/directory/person/status/list
	 * @secure
	 */
	personStatusListList = (
		query?: {
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<PersonStatusResponse[], void>({
			path: `/directory/person/status/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о статусе сотрудников
	 * @request GET:/directory/person/status/{id}
	 * @secure
	 */
	personStatusDetail = (id: number, params: RequestParams = {}) =>
		this.request<PersonStatusResponse, void>({
			path: `/directory/person/status/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование статуса сотрудников
	 * @request PUT:/directory/person/status/{id}
	 * @secure
	 */
	personStatusUpdate = (id: number, data: PersonStatusCreateRequest, params: RequestParams = {}) =>
		this.request<PersonStatusResponse, void | String[]>({
			path: `/directory/person/status/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание угрозы
	 * @request POST:/directory/threat
	 * @secure
	 */
	threatCreate = (data: ThreatCreateRequest, params: RequestParams = {}) =>
		this.request<ThreatShortInfo, void | String[]>({
			path: `/directory/threat`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка возможных угроз
	 * @request GET:/directory/threat/list
	 * @secure
	 */
	threatListList = (
		query?: {
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatShortInfo[], void>({
			path: `/directory/threat/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация об угрозе
	 * @request GET:/directory/threat/{id}
	 * @secure
	 */
	threatDetail = (id: number, params: RequestParams = {}) =>
		this.request<ThreatShortInfo, void>({
			path: `/directory/threat/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование угрозы
	 * @request PUT:/directory/threat/{id}
	 * @secure
	 */
	threatUpdate = (id: number, data: ThreatCreateRequest, params: RequestParams = {}) =>
		this.request<ThreatShortInfo, void | String[]>({
			path: `/directory/threat/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление угрозы
	 * @request DELETE:/directory/threat/{id}
	 * @secure
	 */
	threatDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/threat/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Список шаблонов модели угроз
	 * @request GET:/directory/threat-model-template/list
	 * @secure
	 */
	threatModelTemplateListList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatModelTemplateResponse[], void>({
			path: `/directory/threat-model-template/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление шаблона модели угроз
	 * @request DELETE:/directory/threat-model-template/{id}
	 * @secure
	 */
	threatModelTemplateDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/threat-model-template/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка маркеров организаций
	 * @request GET:/directory/organizations-markers
	 * @secure
	 */
	organizationsMarkersList = (params: RequestParams = {}) =>
		this.request<OrganizationMarkersList, void>({
			path: `/directory/organizations-markers`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание нового маркера
	 * @request POST:/directory/organizations-markers/create_new_marker
	 * @secure
	 */
	organizationsMarkersCreateNewMarkerCreate = (data: OrganizationMarkerRequestParams, params: RequestParams = {}) =>
		this.request<MarkerResponse, void>({
			path: `/directory/organizations-markers/create_new_marker`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование существующего маркера
	 * @request POST:/directory/organizations-markers/{org_marker_id}/edit
	 * @secure
	 */
	organizationsMarkersEditCreate = (
		orgMarkerId: number,
		data: OrganizationMarkerRequestParams,
		params: RequestParams = {},
	) =>
		this.request<MarkerResponse, void | String>({
			path: `/directory/organizations-markers/${orgMarkerId}/edit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление существующего маркера
	 * @request POST:/directory/organizations-markers/{org_marker_id}/delete
	 * @secure
	 */
	organizationsMarkersDeleteCreate = (orgMarkerId?: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/organizations-markers/${orgMarkerId}/delete`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Импорт ОКВЭД
	 * @request POST:/directory/okved/import
	 * @secure
	 */
	okvedImportCreate = (
		data: {
			/** @format binary */
			file?: File;
		},
		params: RequestParams = {},
	) =>
		this.request<String, void>({
			path: `/directory/okved/import`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Результаты импорта ОКВЭД
	 * @request GET:/directory/okved/import/result
	 * @secure
	 */
	okvedImportResultList = (
		query: {
			/** идентификатор импорта */
			key: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ImportStatistics, void>({
			path: `/directory/okved/import/result`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание кода ОКВЭД
	 * @request POST:/directory/okved
	 * @secure
	 */
	okvedCreate = (data: OkvedCodeCreateRequest, params: RequestParams = {}) =>
		this.request<OkvedCodeResponse, void | String[]>({
			path: `/directory/okved`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка кодов ОКВЭД
	 * @request GET:/directory/okved/list
	 * @secure
	 */
	okvedListList = (
		query: {
			/** строка поиска */
			query?: string;
			/**
			 * id организации
			 * @format int32
			 */
			organization?: number;
			/** код раздела */
			section?: string;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (по умолчанию 30)
			 * @format int32
			 */
			num?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OkvedCodesListItem[], void>({
			path: `/directory/okved/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о коде ОКВЭД
	 * @request GET:/directory/okved/{code}
	 * @secure
	 */
	okvedDetail = (code: string, params: RequestParams = {}) =>
		this.request<OkvedCodeResponse, void>({
			path: `/directory/okved/${code}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование кода ОКВЭД
	 * @request PUT:/directory/okved/{code}
	 * @secure
	 */
	okvedUpdate = (code: string, data: OkvedCodeCreateRequest, params: RequestParams = {}) =>
		this.request<OkvedCodeResponse, void | String[]>({
			path: `/directory/okved/${code}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление кода ОКВЭД
	 * @request DELETE:/directory/okved/{code}
	 * @secure
	 */
	okvedDelete = (code: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/okved/${code}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка разделов кодов ОКВЭД
	 * @request GET:/directory/okved/section/list
	 * @secure
	 */
	okvedSectionListList = (params: RequestParams = {}) =>
		this.request<OkvedCodeSectionResponse[], void>({
			path: `/directory/okved/section/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о разделе кодов ОКВЭД
	 * @request GET:/directory/okved/section/{code}
	 * @secure
	 */
	okvedSectionDetail = (code: string, params: RequestParams = {}) =>
		this.request<OkvedCodeResponse, void>({
			path: `/directory/okved/section/${code}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование раздела кодов ОКВЭД
	 * @request PUT:/directory/okved/section/{code}
	 * @secure
	 */
	okvedSectionUpdate = (code: string, data: OkvedCodeSectionCreateRequest, params: RequestParams = {}) =>
		this.request<OkvedCodeResponse, void | String[]>({
			path: `/directory/okved/section/${code}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление раздела кодов ОКВЭД
	 * @request DELETE:/directory/okved/section/{code}
	 * @secure
	 */
	okvedSectionDelete = (code: string, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/okved/section/${code}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание показателя критериев значимости
	 * @request POST:/directory/significance-criteria
	 * @secure
	 */
	significanceCriteriaCreate = (data: SignificanceCriteriaCreateRequest, params: RequestParams = {}) =>
		this.request<SignificanceCriteriaResponse, void | String[]>({
			path: `/directory/significance-criteria`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка показателей критериев значимости
	 * @request GET:/directory/significance-criteria/list
	 * @secure
	 */
	significanceCriteriaListList = (
		query: {
			/** строка поиска */
			query?: string;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (по умолчанию 30)
			 * @format int32
			 */
			num?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<SignificanceCriteriaSectionInfo[], void>({
			path: `/directory/significance-criteria/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка показателей критериев значимости (архив)
	 * @request GET:/directory/significance-criteria/list/archive
	 * @secure
	 */
	significanceCriteriaListArchiveList = (
		query: {
			/** строка поиска */
			query?: string;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (по умолчанию 30)
			 * @format int32
			 */
			num?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<SignificanceCriteriaSectionInfo[], void>({
			path: `/directory/significance-criteria/list/archive`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Информация о показателе критериев значимости
	 * @request GET:/directory/significance-criteria/{id}
	 * @secure
	 */
	significanceCriteriaDetail = (id: number, params: RequestParams = {}) =>
		this.request<SignificanceCriteriaResponse, void>({
			path: `/directory/significance-criteria/${id}`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование показателя критериев значимости
	 * @request PUT:/directory/significance-criteria/{id}
	 * @secure
	 */
	significanceCriteriaUpdate = (id: number, data: SignificanceCriteriaCreateRequest, params: RequestParams = {}) =>
		this.request<SignificanceCriteriaResponse, void | String | String[]>({
			path: `/directory/significance-criteria/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление показателя критериев значимости
	 * @request DELETE:/directory/significance-criteria/{id}
	 * @secure
	 */
	significanceCriteriaDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/significance-criteria/${id}`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Поместить показатель критериев значимости в архив
	 * @request GET:/directory/significance-criteria/{id}/archive
	 * @secure
	 */
	significanceCriteriaArchiveDetail = (id: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/directory/significance-criteria/${id}/archive`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Восстановить показатель критериев значимости из архива
	 * @request DELETE:/directory/significance-criteria/{id}/archive
	 * @secure
	 */
	significanceCriteriaArchiveDelete = (id: number, params: RequestParams = {}) =>
		this.request<void, void | String[]>({
			path: `/directory/significance-criteria/${id}/archive`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка разделов показателей критериев значимости
	 * @request GET:/directory/significance-criteria/section/list
	 * @secure
	 */
	significanceCriteriaSectionListList = (
		query: {
			/** строка поиска */
			query?: string;
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (по умолчанию 30)
			 * @format int32
			 */
			num?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<String[], void>({
			path: `/directory/significance-criteria/section/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка типов шаблонов документов
	 * @request GET:/directory/docx-templates/list_template_types
	 * @secure
	 */
	docxTemplatesListTemplateTypesList = (params: RequestParams = {}) =>
		this.request<DocumentPatternTypeResponse[], void>({
			path: `/directory/docx-templates/list_template_types`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка шаблонов документов(только системных)
	 * @request GET:/directory/docx-templates/list
	 * @secure
	 */
	docxTemplatesListList = (params: RequestParams = {}) =>
		this.request<DocumentPatternResponse[], void>({
			path: `/directory/docx-templates/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка шаблонов документов(если нет организационных, отобразятся системные)
	 * @request GET:/directory/docx-templates/{org_id}/list
	 * @secure
	 */
	docxTemplatesListDetail = (orgId: number, params: RequestParams = {}) =>
		this.request<DocumentPatternResponse[], void>({
			path: `/directory/docx-templates/${orgId}/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание нового шаблона
	 * @request POST:/directory/docx-templates/create_new_template_from_system(копированием системного шаблона)
	 * @secure
	 */
	docxTemplatesCreateNewTemplateFromSystemКопированиемСистемногоШаблонаCreate = (
		data: DocxTemplateRequestParams,
		params: RequestParams = {},
	) =>
		this.request<DocumentPatternResponse, void>({
			path: `/directory/docx-templates/create_new_template_from_system(копированием системного шаблона)`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание/замещение нового шаблона(выгрузкой файла)
	 * @request POST:/directory/docx-templates/update_or_create_template_by_upload
	 * @secure
	 */
	docxTemplatesUpdateOrCreateTemplateByUploadCreate = (
		data: {
			/** @format binary */
			Template?: File;
			params?: DocxTemplateRequestParams;
		},
		params: RequestParams = {},
	) =>
		this.request<DocumentPatternResponse, void>({
			path: `/directory/docx-templates/update_or_create_template_by_upload`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование сопутствующей информации существующего шаблона
	 * @request POST:/directory/docx-templates/{docx_template_id}/edit
	 * @secure
	 */
	docxTemplatesEditCreate = (data: DocxTemplateRequestParams, docxTemplateId?: number, params: RequestParams = {}) =>
		this.request<DocumentPatternResponse, void>({
			path: `/directory/docx-templates/${docxTemplateId}/edit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Установить организационный шаблон для документов по умолчанию
	 * @request POST:/directory/docx-templates/{docx_template_id}/activate
	 * @secure
	 */
	docxTemplatesActivateCreate = (docxTemplateId?: number, params: RequestParams = {}) =>
		this.request<DocumentPatternResponse, void>({
			path: `/directory/docx-templates/${docxTemplateId}/activate`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Установить системный шаблон для документов по умолчанию
	 * @request POST:/directory/docx-templates/{docx_template_id}/deactivate
	 * @secure
	 */
	docxTemplatesDeactivateCreate = (docxTemplateId?: number, params: RequestParams = {}) =>
		this.request<DocumentPatternResponse, void>({
			path: `/directory/docx-templates/${docxTemplateId}/deactivate`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ, Справочники
	 * @summary Получение документа подсказки
	 * @request GET:/directory/docx-templates/get_help
	 * @secure
	 */
	docxTemplatesGetHelpList = (params: RequestParams = {}) =>
		this.request<Application, void>({
			path: `/directory/docx-templates/get_help`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление существующего шаблона
	 * @request POST:/directory/docx-templates/{docx_template_id}/delete
	 * @secure
	 */
	docxTemplatesDeleteCreate = (docxTemplateId?: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/docx-templates/${docxTemplateId}/delete`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ, Справочники
	 * @summary Получение документа по его id
	 * @request GET:/directory/docx-templates/{docx_template_id}/get
	 * @secure
	 */
	docxTemplatesGetDetail = (docxTemplateId: number, params: RequestParams = {}) =>
		this.request<Application, void>({
			path: `/directory/docx-templates/${docxTemplateId}/get`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Перечень ОКИИ, Справочники
	 * @summary Замена шаблона другим шаблоном
	 * @request POST:/directory/docx-templates/{docx_template_id}/{user_name}/upload
	 * @secure
	 */
	docxTemplatesUploadCreate = (
		docxTemplateId: number,
		data: {
			/** @format binary */
			ApprovedDoc?: File;
		},
		userName?: string,
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/directory/docx-templates/${docxTemplateId}/${userName}/upload`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.FormData,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Получение списка статусов объектов
	 * @request GET:/directory/object-statuses/list
	 * @secure
	 */
	objectStatusesListList = (params: RequestParams = {}) =>
		this.request<ObjectStatusResponseRELOAD[], void>({
			path: `/directory/object-statuses/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Создание нового статуса
	 * @request POST:/directory/object-statuses/create_new_status
	 * TODO: неверный формат возвращаемых значений
	 * @secure
	 */
	objectStatusesCreateNewStatusCreate = (data: ObjectStatusRequestParams, params: RequestParams = {}) =>
		this.request<ObjectStatusResponseRELOAD, void>({
			path: `/directory/object-statuses/create_new_status`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование существующего статуса
	 * @request POST:/directory/object-statuses/{obj_status_id}/edit
	 * @secure
	 */
	objectStatusesEditCreate = (objStatusId: number, data: ObjectStatusRequestParams, params: RequestParams = {}) =>
		this.request<ObjectStatusResponseRELOAD, void>({
			path: `/directory/object-statuses/${objStatusId}/edit`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление существующего статуса
	 * @request POST:/directory/object-statuses/{obj_status_id}/delete
	 * @secure
	 */
	objectStatusesDeleteCreate = (objStatusId: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/object-statuses/${objStatusId}/delete`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Отключение существующего статуса
	 * @request POST:/directory/object-statuses/{obj_status_id}/disable
	 * @secure
	 */
	objectStatusesDisableCreate = (objStatusId: number, params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/directory/object-statuses/${objStatusId}/disable`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Статус заполненности справочников
	 * @request GET:/directory/emptiness-status
	 * @secure
	 */
	emptinessStatusList = (params: RequestParams = {}) =>
		this.request<DirectoryEmptinessResponse, void>({
			path: `/directory/emptiness-status`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Последствия реализации угроз
	 * @request GET:/directory/threat-consequences
	 * @secure
	 */
	threatConsequencesList = (
		query?: {
			/** Поисковый запрос */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ThreatConsequenceResponse[], void>({
			path: `/directory/threat-consequences`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Добавление последствия угрозы
	 * @request POST:/directory/threat-consequences
	 * @secure
	 */
	threatConsequencesCreate = (data: ConsequenceParams, params: RequestParams = {}) =>
		this.request<ThreatConsequenceResponse, void>({
			path: `/directory/threat-consequences`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Редактирование последствия угрозы
	 * @request PUT:/directory/threat-consequences/{id}
	 * @secure
	 */
	threatConsequencesUpdate = (id: number, data: ConsequenceParams, params: RequestParams = {}) =>
		this.request<ThreatConsequenceResponse, void>({
			path: `/directory/threat-consequences/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Справочники
	 * @summary Удаление/архивирование последствия угрозы
	 * @request DELETE:/directory/threat-consequences/{id}
	 * @secure
	 */
	threatConsequencesDelete = (
		id: number,
		query: {
			/** true если архивировать, false если удалить */
			archive: boolean;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/directory/threat-consequences/${id}`,
			method: "DELETE",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Список типов организации по иерархии (для выбора при добавлении/редактировании организации)
	 * @request GET:/directory/organization-types
	 * @secure
	 */
	organizationTypesList = (
		query?: {
			/**
			 * id организации
			 * @format int32
			 */
			id?: number;
			/**
			 * id родительской организации
			 * @format int32
			 */
			parent?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationTypeResponse[], void>({
			path: `/directory/organization-types`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Список типов организации
	 * @request GET:/directory/property-types
	 * @secure
	 */
	propertyTypesList = (params: RequestParams = {}) =>
		this.request<OrganizationTypeResponse, void>({
			path: `/directory/property-types`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Список материнских организаций
	 * @request GET:/directory/organizations/parent
	 * @secure
	 */
	organizationsParentList = (
		query: {
			/**
			 * id типа организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationParentResponse[], void>({
			path: `/directory/organizations/parent`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Список адресов объекта организации
	 * @request GET:/directory/object/{id}/locations
	 * @secure
	 */
	objectLocationsDetail = (id: number, params: RequestParams = {}) =>
		this.request<ObjectLocationInfoResponse[], void>({
			path: `/directory/object/${id}/locations`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка уровней возможностей нарушителей
	 * @request GET:/directory/violator-levels
	 * @secure
	 */
	violatorLevelsList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id?: number;
			/** Тип уровня */
			type: "VIOLATOR" | "THREAT" | "GROUP" | "ESTIMATION";
		},
		params: RequestParams = {},
	) =>
		this.request<ViolatorLevelResponse[], void>({
			path: `/directory/violator-levels`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка видов нарушителей
	 * @request GET:/directory/collusion
	 * @secure
	 */
	collusionList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id?: number;
			/** Тип уровня */
			type: "VIOLATOR" | "THREAT" | "GROUP" | "ESTIMATION";
		},
		params: RequestParams = {},
	) =>
		this.request<ViolatorTypeTemplate[], void>({
			path: `/directory/collusion`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Поиск объектов воздействий (видов воздействий)
	 * @request GET:/directory/influence/search
	 * @secure
	 */
	influenceSearchList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			objectID: number;
			/** Поисковый запрос */
			query: string;
		},
		params: RequestParams = {},
	) =>
		this.request<InfluenceObjectInfoResponse[], void>({
			path: `/directory/influence/search`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description Поиск осуществляется по полям - порядковый номер, наименование
	 *
	 * @tags Списки для выбора
	 * @summary Поиск бизнес-процессов для выбора
	 * @request GET:/directory/processes/search
	 * @secure
	 */
	processesSearchList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			org_id: number;
			/** Поисковый запрос */
			query: string;
		},
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessInfoResponse[], void>({
			path: `/directory/processes/search`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка бизнес-процессов для выбора
	 * @request GET:/directory/processes
	 * @secure
	 */
	processesList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			org_id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessInfoResponse[], void>({
			path: `/directory/processes`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description Поиск осуществляется по полям - код, наименование
	 *
	 * @tags Списки для выбора
	 * @summary Поиск объектов организации для выбора
	 * @request GET:/directory/objects/search
	 * @secure
	 */
	objectsSearchList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			org_id: number;
			/** Поисковый запрос */
			query: string;
		},
		params: RequestParams = {},
	) =>
		this.request<OrganizationObjectInfoResponse[], void>({
			path: `/directory/objects/search`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка организаций для выбора
	 * @request GET:/directory/organizations
	 * @secure
	 */
	organizationsList = (params: RequestParams = {}) =>
		this.request<OrganizationSimpleResponse[], void>({
			path: `/directory/organizations`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка классов бизнес-процессов
	 * @request GET:/directory/bp-classes
	 * @secure
	 */
	bpClassesList = (params: RequestParams = {}) =>
		this.request<BPClassInfoResponse[], void>({
			path: `/directory/bp-classes`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка шаблонов бизнес-процессов организации
	 * @request GET:/directory/bp-patterns
	 * @secure
	 */
	bpPatternsList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<BusinessProcessPatternInfoResponse[], void>({
			path: `/directory/bp-patterns`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка видов деятельности
	 * @request GET:/directory/activity-types
	 * @secure
	 */
	activityTypesList = (params: RequestParams = {}) =>
		this.request<ActivityTypeSimpleResponse[], void>({
			path: `/directory/activity-types`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка сотрудников организации для выбора
	 * @request GET:/directory/employees
	 * @secure
	 */
	employeesList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			org_id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<EmployeeSimpleResponse[], void>({
			path: `/directory/employees`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка типов отношений с организацией
	 * @request GET:/directory/employee-relationship
	 * @secure
	 */
	employeeRelationshipList = (params: RequestParams = {}) =>
		this.request<PersonRelationshipResponse[], void>({
			path: `/directory/employee-relationship`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка адресов объектов капитального строительства
	 * @request GET:/directory/construction-objects
	 * @secure
	 */
	constructionObjectsList = (params: RequestParams = {}) =>
		this.request<ConstructionObjectInfoResponse[], void>({
			path: `/directory/construction-objects`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Поиск адресов объектов капительного строительства
	 * @request GET:/directory/construction-objects/search
	 * @secure
	 */
	constructionObjectsSearchList = (
		query: {
			/** Поисковый запрос */
			query: string;
		},
		params: RequestParams = {},
	) =>
		this.request<ConstructionObjectInfoResponse[], void>({
			path: `/directory/construction-objects/search`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора, Списки для выбора
	 * @summary Получение списка сотрудников для выбора
	 * @request GET:/directory/dropdown/employees
	 * @secure
	 */
	dropdownEmployeesList = (params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/directory/dropdown/employees`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получить список негативных последствий для выбора
	 * @request GET:/directory/dropdown/influences
	 * @secure
	 */
	dropdownInfluencesList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<RiskTypeShortResponse[], void>({
			path: `/directory/dropdown/influences`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получить список типов нарушителя для выбора
	 * @request GET:/directory/dropdown/violator-types
	 * @secure
	 */
	dropdownViolatorTypesList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<String[], void>({
			path: `/directory/dropdown/violator-types`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка источников угроз для выбора
	 * @request GET:/directory/dropdown/threat-sources
	 * @secure
	 */
	dropdownThreatSourcesList = (params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/directory/dropdown/threat-sources`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка негативных последствий
	 * @request GET:/directory/dropdown/consequences
	 * @secure
	 */
	dropdownConsequencesList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<String[], void>({
			path: `/directory/dropdown/consequences`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка видов актуальных нарушителей
	 * @request GET:/directory/dropdown/actual-violator-types
	 * @secure
	 */
	dropdownActualViolatorTypesList = (
		query: {
			/**
			 * id объекта организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ActualViolatorTypeResponse[], void>({
			path: `/directory/dropdown/actual-violator-types`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка объектов воздействия
	 * @request GET:/directory/dropdown/object/additional/influences
	 * @secure
	 */
	dropdownObjectAdditionalInfluencesList = (params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/directory/dropdown/object/additional/influences`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получение списка технических средств для выбора
	 * @request GET:/directory/dropdown/threat/{id}/technical-means
	 * @secure
	 */
	dropdownThreatTechnicalMeansDetail = (
		query: {
			/** Список для редактирования, либо для нового элемента (true = редактирование, false = новый) */
			edit: boolean;
			/**
			 * Партия
			 * @format int32
			 */
			part: number;
			/**
			 * Количество
			 * @format int32
			 */
			count: number;
		},
		id?: number,
		params: RequestParams = {},
	) =>
		this.request<ObjectInfluenceResponse[], void>({
			path: `/directory/dropdown/threat/${id}/technical-means`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получить список наименований сегментов для выбора
	 * @request GET:/directory/dropdown/segment/names
	 * @secure
	 */
	dropdownSegmentNamesList = (
		query?: {
			/** @format int32 */
			page?: number;
			/** @format int32 */
			num?: number;
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<String[], void>({
			path: `/directory/dropdown/segment/names`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Списки для выбора
	 * @summary Получить разделы таблицы для перечня средств защиты информации
	 * @request GET:/directory/dropdown/security-tool/segments
	 * @secure
	 */
	dropdownSecurityToolSegmentsList = (params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/directory/dropdown/security-tool/segments`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
}
export const directoryAPI = new Directory();
